import api from './api'

export function searchByRef(farmaciaId, ref, tipo) {
  return new Promise(async (resolve, reject) => {
    try {
      const token = localStorage.getItem('FORMULARIO_JSONWEBTOKEN');

      const response = await api.get(`farmacias/${farmaciaId}/veiculos_utilizacao/search`, {
        headers: { authorization: `Bearer ${token}` },
        params: { ref, tipo }
      });

      return resolve(response.data.data);
    } catch (e) {
      return reject(e);
    }
  })
}
